import {getCountry, getWithDotComByCountry} from '@/store/util';

const country = getCountry();
const withCom = getWithDotComByCountry(country);

export const env = {
  NODE_ENV: 'production',
  CLIENT_ID: 'neodash',
  URL: {
    HOST: `https://neodash-api.neogig${withCom}${country}`,
    NEOGIG: `https://www.neogig${withCom}${country}`,
    NEOGIG_API: `https://neogig-api.neogig${withCom}${country}/api/v1`,
    NEOGIG_IMAGE: `https://www.neogig${withCom}${country}/static/images`,
    NEODASH_API: `https://neodash-api.neogig${withCom}${country}`,
    REPORT_VIEWER: `https://rpt.neogig${withCom}${country}`,
    CTRL_PANEL_API: `https://cp-api.neogig${withCom}${country}`,
    IDENTITY_SERVER: `https://identity-server.neogig${withCom}${country}`,
    WEBSOCKET: `wss://www.neogig${withCom}${country}/neodash_api/WsSocketHandler.ashx`,
    PBIURL: `https://app.powerbi.com/`,
  }
};
